import { continuesText } from '../../../../utils/continues-text'
import type { ResolvedPart } from './use-interleaved-parts'

/**
 * Joins a text part that a model step cut off mid-sentence with the next
 * step's text that carries it on. A model can write half a sentence, call a
 * tool, and finish the sentence in the next step, which the server sends as a
 * separate message. The joined text takes the later part's key, so it stays
 * the answer when the later step is the primary message, and the tool calls in
 * between stay ahead of it.
 */
export function joinContinuedText(parts: Array<ResolvedPart>): Array<ResolvedPart> {
  const joined: Array<ResolvedPart> = []
  let openTextIndex = -1
  for (const part of parts) {
    if (part.type !== 'text') {
      joined.push(part)
      continue
    }
    const open = joined[openTextIndex]
    if (open?.type === 'text' && continuesText(open.text, part.text)) {
      joined.splice(openTextIndex, 1)
      joined.push({ ...part, text: open.text + part.text })
    } else {
      joined.push(part)
    }
    openTextIndex = joined.length - 1
  }
  return joined
}
